import getColor from '@gc-npm/utils.enums.colors';
import {
  SWITCH_TYPE,
} from './enums.js';
  
  
  /**
   * Calcula la clase CSS refente al tema/tipo del botón, no necesita segmento, ya uqe lo pilla de entorno
   * @returns type-gp--primary or type-gp--secondary or type-gp--danger
   */
  export const getSwitchTypeCss = (switchTypeProp, isOn) => {
    // primary by default
    let style ={
      backgroundColor: isOn ? getColor('blue_a') : getColor('grey3') ,
    }
    if (switchTypeProp === SWITCH_TYPE.PRIMARY_REVERSE) {
      style={
        backgroundColor: isOn ? getColor('grey3') : getColor('blue_a'),
      }
    }
    if (switchTypeProp === SWITCH_TYPE.SECONDARY) {
      style = {
        backgroundColor: getColor('white'),
        outline: `1px solid ${getColor('blue_a')}`,
      }
    }
    if (switchTypeProp === SWITCH_TYPE.SECONDARY_REVERSE) {
      style = {
        backgroundColor: isOn ? getColor('blue_a') : getColor('white'),
        outline: `1px solid ${getColor('white')}`,
      }
    }
    

    return style;
  };


  /**
   * Calcula la clase CSS refente al tema/tipo del botón, no necesita segmento, ya uqe lo pilla de entorno
   * @returns type-gp--primary or type-gp--secondary or type-gp--danger
   */
  export const getSwitchThumbTypeCss = (switchTypeProp) => {
    // primary by default
    let style ={
      backgroundColor: getColor('white'),
    }
    if (switchTypeProp === SWITCH_TYPE.PRIMARY_REVERSE) {
      style={
        backgroundColor: getColor('white'),
      }
    }
    if (switchTypeProp === SWITCH_TYPE.SECONDARY) {
      style = {
        backgroundColor: getColor('blue_a'),
      }
    }
    

    return style;
  }; 

  

  export const composeCssClassNamesAndStyles = ({
    type,
    isOn,
    disabled,
    className,
  }) => {
    const statusCss = disabled ? 'status--disabled' : '';
    const customClassName = className ? `${className} ` : '';
    const cssClassNames = `switch ${customClassName} switch-type--${type}  ${statusCss}`
    // styles
    const switchStyles = getSwitchTypeCss(type, isOn);
    const switchThumbStyles = getSwitchThumbTypeCss(type);
    return {
      cssClassNames,
      switchStyles,
      switchThumbStyles,
    }
  }

